import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, SentryErrorBoundary } from './lib/sentry';
import App from './App';
import './index.css';

// Initialize Sentry first
initSentry();

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center p-8">
        <h1 className="text-2xl font-bold mb-2 text-gray-900">
          Something went wrong
        </h1>
        <p className="text-gray-600 mb-4">
          We&apos;ve been notified and are working on it.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-vinotinto text-white rounded-lg hover:opacity-90"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>,
);
